export default "__VITE_ASSET__DGJHEtSy__"